/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Profile_Editors_Split_RecommendedInputs */

const en_us2_profile_editors_split_recommended = /** @type {(inputs: Profile_Editors_Split_RecommendedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} · recommended`)
};

const pt_br2_profile_editors_split_recommended = /** @type {(inputs: Profile_Editors_Split_RecommendedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} · recomendado`)
};

const es_419_profile_editors_split_recommended = /** @type {(inputs: Profile_Editors_Split_RecommendedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} · recomendada`)
};

const pt_pt2_profile_editors_split_recommended = /** @type {(inputs: Profile_Editors_Split_RecommendedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} · recomendada`)
};

const fr_fr2_profile_editors_split_recommended = /** @type {(inputs: Profile_Editors_Split_RecommendedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} · recommandé`)
};

const de_de2_profile_editors_split_recommended = /** @type {(inputs: Profile_Editors_Split_RecommendedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} · empfohlen`)
};

const it_it2_profile_editors_split_recommended = /** @type {(inputs: Profile_Editors_Split_RecommendedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} · consigliato`)
};

/**
* | output |
* | --- |
* | "{name} · recommended" |
*
* @param {Profile_Editors_Split_RecommendedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_split_recommended = /** @type {((inputs: Profile_Editors_Split_RecommendedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Split_RecommendedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_split_recommended(inputs)
	if (locale === "es-419") return es_419_profile_editors_split_recommended(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_split_recommended(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_split_recommended(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_split_recommended(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_split_recommended(inputs)
	return en_us2_profile_editors_split_recommended(inputs)
});
export { profile_editors_split_recommended as "profile-editors.split_recommended" }